/**
 * Posts a success message to the window opener (for popup scenarios)
 */
export function postMessageToOpener(
  publicToken: string,
  nonce: string | string[] | null | undefined,
  origin: string | string[] | null | undefined,
): void {
  try {
    if (window.opener) {
      window.opener.postMessage(
        JSON.stringify({
          publicToken,
          nonce,
          type: "SUCCESS",
        }),
        origin,
      );
    }
  } catch (e) {
    console.error("[v0] Error posting message to opener:", e);
    throw e;
  }
}

/**
 * Parses query string parameters from location search
 */
export function parseQueryParams(search: string) {
  const qs = require("query-string");
  const parsedSearch = qs.parse(search);
  return {
    origin: parsedSearch.origin,
    nonce: parsedSearch.nonce,
    parsedSearch,
  };
}
